(() => {
  const root = document.documentElement;
  const body = document.body;
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const lock = () => {
    root.classList.add("diverge-locked");
    body.style.overflow = "hidden";
  };
  const unlock = () => {
    root.classList.remove("diverge-locked");
    body.style.removeProperty("overflow");
  };

  const intro = $("#diverge-cinematic");
  if (intro) {
    const params = new URLSearchParams(location.search);
    let entered = false;
    try {
      entered = sessionStorage.getItem("diverge-entered-v3") === "true";
    } catch (_) {}
    const skip =
      matchMedia("(prefers-reduced-motion: reduce)").matches ||
      params.get("animation") === "0" ||
      (entered && params.get("animation") !== "1");
    const closeIntro = () => {
      if (!intro.isConnected || intro.classList.contains("leaving")) return;
      intro.classList.add("leaving");
      try {
        sessionStorage.setItem("diverge-entered-v3", "true");
      } catch (_) {}
      window.setTimeout(() => {
        intro.remove();
        $("#diverge-site-content")?.removeAttribute("inert");
        $("#diverge-site-content")?.removeAttribute("aria-hidden");
        unlock();
      }, 900);
    };
    if (skip) {
      intro.remove();
      $("#diverge-site-content")?.removeAttribute("inert");
      $("#diverge-site-content")?.removeAttribute("aria-hidden");
    } else {
      $("#diverge-site-content")?.setAttribute("inert", "");
      $("#diverge-site-content")?.setAttribute("aria-hidden", "true");
      lock();
      requestAnimationFrame(() => $(".cinematic-center button", intro)?.focus());
      $$("[data-close-intro]", intro).forEach((button) =>
        button.addEventListener("click", closeIntro),
      );
      intro.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeIntro();
      });
      window.setTimeout(() => {
        if (intro.isConnected && !$(".cinematic-center button", intro)) closeIntro();
      }, 3000);
    }
  }

  const overlay = $("#diverge-overlay");
  const drawers = $$(".side-drawer");
  const siteContent = $("#diverge-site-content");
  let activeDrawer = null;
  let returnFocus = null;
  const focusableSelector =
    'a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const setBackgroundInert = (inert) => {
    if (!siteContent) return;
    if (inert) {
      siteContent.setAttribute("inert", "");
      siteContent.setAttribute("aria-hidden", "true");
    } else if (!$("#diverge-cinematic")) {
      siteContent.removeAttribute("inert");
      siteContent.removeAttribute("aria-hidden");
    }
  };
  const closeDrawers = () => {
    drawers.forEach((drawer) => {
      drawer.classList.remove("open");
      drawer.setAttribute("aria-hidden", "true");
    });
    overlay?.classList.remove("open");
    $$("[data-open-drawer]").forEach((trigger) =>
      trigger.setAttribute("aria-expanded", "false"),
    );
    setBackgroundInert(false);
    unlock();
    activeDrawer = null;
    returnFocus?.focus();
    returnFocus = null;
  };
  $$("[data-open-drawer]").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const drawer = document.getElementById(trigger.dataset.openDrawer);
      if (!drawer) return;
      closeDrawers();
      activeDrawer = drawer;
      returnFocus = trigger;
      drawer.classList.add("open");
      drawer.setAttribute("aria-hidden", "false");
      trigger.setAttribute("aria-expanded", "true");
      overlay?.classList.add("open");
      setBackgroundInert(true);
      lock();
      window.setTimeout(() => $(focusableSelector, drawer)?.focus(), 50);
    });
  });
  $$("[data-close-drawer]").forEach((button) =>
    button.addEventListener("click", closeDrawers),
  );
  overlay?.addEventListener("click", closeDrawers);
  document.addEventListener("keydown", (event) => {
    if (!activeDrawer) return;
    if (event.key === "Escape") {
      closeDrawers();
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = $$(focusableSelector, activeDrawer);
    if (!focusable.length) return;
    if (event.shiftKey && document.activeElement === focusable[0]) {
      event.preventDefault();
      focusable.at(-1).focus();
    } else if (!event.shiftKey && document.activeElement === focusable.at(-1)) {
      event.preventDefault();
      focusable[0].focus();
    }
  });

  const searchInput = $("#drawer-search");
  const results = $("#diverge-drawer-results");
  let searchController;
  const escapeHtml = (value) =>
    String(value).replace(
      /[&<>"']/g,
      (char) =>
        ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" })[
          char
        ],
    );
  searchInput?.addEventListener("input", async () => {
    const query = searchInput.value.trim();
    const viewAll = $("#diverge-view-results");
    if (viewAll) viewAll.href = `${window.divergeRoutes.search}?q=${encodeURIComponent(query)}`;
    if (!query) {
      results.innerHTML = "";
      return;
    }
    searchController?.abort();
    searchController = new AbortController();
    try {
      const response = await fetch(
        `${window.divergeRoutes.predictive}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`,
        { signal: searchController.signal },
      );
      if (!response.ok) throw new Error("Search unavailable");
      const payload = await response.json();
      const products = payload.resources?.results?.products || [];
      results.innerHTML = products.length
        ? products
            .map((product) => {
              const image =
                typeof product.image === "string"
                  ? product.image
                  : product.featured_image?.url || product.image?.url || "";
              return `<a href="${escapeHtml(product.url)}">
                ${image ? `<img src="${escapeHtml(image)}" alt="" width="120" height="120">` : ""}
                <span><b>${escapeHtml(product.title)}</b><small>${escapeHtml(product.price || "")}</small></span><i aria-hidden="true">↗</i>
              </a>`;
            })
            .join("")
        : '<p class="drawer-empty">No matching pieces.</p>';
    } catch (error) {
      if (error.name !== "AbortError")
        results.innerHTML = '<p class="drawer-empty">Search is temporarily unavailable.</p>';
    }
  });

  const syncSiteChromeHeight = () => {
    const bar = $("[data-site-chrome-bar]");
    const route = $("[data-route-line]");
    const header = $("#site-header");
    if (route) {
      document.documentElement.style.setProperty("--route-line-height", `${route.offsetHeight}px`);
    }
    if (header) {
      document.documentElement.style.setProperty("--site-header-height", `${header.offsetHeight}px`);
    }
    if (bar) {
      document.documentElement.style.setProperty("--site-chrome-bar-height", `${bar.offsetHeight}px`);
    }
    if (bar || route) {
      const total = (bar?.offsetHeight || 0) + (route?.offsetHeight || 0);
      document.documentElement.style.setProperty("--site-chrome-height", `${total}px`);
    }
  };

  const initStickyHeader = () => {
    const bar = $("[data-site-chrome-bar]");
    const announcement = bar ? $(".announcement", bar) : null;
    const header = $("#site-header");
    if (!bar || !announcement || !header) return;

    let spacer = null;

    const updateHeaderPin = () => {
      syncSiteChromeHeight();
      const announceHeight = announcement.offsetHeight;
      const headerHeight = header.offsetHeight;
      const shouldPin = window.scrollY >= announceHeight;

      if (shouldPin) {
        header.classList.add("is-pinned");
        if (!spacer) {
          spacer = document.createElement("div");
          spacer.className = "site-header-spacer";
          spacer.setAttribute("aria-hidden", "true");
          header.after(spacer);
        }
        spacer.style.height = `${headerHeight}px`;
      } else {
        header.classList.remove("is-pinned");
        spacer?.remove();
        spacer = null;
      }
    };

    updateHeaderPin();
    window.addEventListener("scroll", updateHeaderPin, { passive: true });
    window.addEventListener("resize", updateHeaderPin);
  };

  initStickyHeader();
  syncSiteChromeHeight();
  window.addEventListener("resize", syncSiteChromeHeight);

  const initNewsletterSignup = (form) => {
    const emailInput = $("#newsletter-email", form);
    const phoneInput = $("#newsletter-phone", form);
    const countryCodeInput = $("[id^='NewsletterCountryCode--']", form);
    const smsConsentInput = $("[id^='NewsletterSmsConsent--']", form);
    const smsRow = $("[id^='NewsletterSmsRow--']", form);
    const emailField = $("[id^='NewsletterEmailField--']", form);
    const phoneField = $("[id^='NewsletterPhoneField--']", form);
    const submitButton = $("[id^='NewsletterCombinedSubmit--']", form);
    const nativeSubmitButton = $("[id^='NewsletterNativeSubmit--']", form);
    const shopifyPhoneInput = $("[id^='NewsletterShopifyPhone--']", form);
    const shopifySmsPhoneNoteInput = $("[id^='NewsletterSmsPhoneNote--']", form);
    const shopifySmsConsentNoteInput = $("[id^='NewsletterSmsConsentNote--']", form);
    if (!emailInput || !phoneInput || !countryCodeInput || !smsConsentInput || !smsRow || !emailField || !phoneField || !submitButton || !nativeSubmitButton) return;

    let isSubmitting = false;
    const config = window.divergeNewsletter || {};
    const turnstileSiteKey = form.querySelector(".cf-turnstile")?.dataset.sitekey;

    const hasValue = (input) => input.value.trim().length > 0;
    const getUsLocalDigits = (value) => {
      let digits = (value || "").replace(/\D/g, "");
      if (digits.length === 11 && digits.charAt(0) === "1") digits = digits.slice(1);
      return digits.slice(0, 10);
    };
    const formatPhoneAsUs = (value) => {
      const digits = getUsLocalDigits(value);
      if (digits.length <= 3) return digits;
      if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
      return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    };
    const syncSmsVisibility = () => {
      const visible = hasValue(emailInput);
      smsRow.classList.toggle("is-visible", visible);
      smsRow.setAttribute("aria-hidden", visible ? "false" : "true");
    };
    const syncSubmitButtonPosition = () => {
      const targetField = hasValue(phoneInput) ? phoneField : emailField;
      if (submitButton.parentElement !== targetField) targetField.appendChild(submitButton);
    };
    const syncUi = () => {
      const formatted = formatPhoneAsUs(phoneInput.value);
      if (phoneInput.value !== formatted) phoneInput.value = formatted;
      syncSmsVisibility();
      syncSubmitButtonPosition();
    };
    const setSubmitLoading = (loading) => {
      submitButton.classList.toggle("is-loading", !!loading);
      submitButton.setAttribute("aria-busy", loading ? "true" : "false");
    };
    const subscribeViaKlaviyoApi = async (emailValue, phoneWithCountry, smsConsent) => {
      if (!config.companyId || !config.listId || !config.workerUrl) return false;
      try {
        const response = await fetch(config.workerUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            companyId: config.companyId,
            listId: config.listId,
            email: emailValue || "",
            phoneNumber: phoneWithCountry || "",
            smsConsent: !!smsConsent,
            source: form.dataset.newsletterSource || "footer",
            turnstileToken: window.__divergeTurnstileToken || "",
          }),
        });
        return response.ok || response.status === 202;
      } catch (_) {
        return false;
      }
    };

    submitButton.addEventListener("click", async () => {
      if (isSubmitting) return;
      if (!form.reportValidity()) return;
      const emailValue = emailInput.value.trim();
      const rawCountryCode = (countryCodeInput.value || "+1").trim();
      let sanitizedCountryCode = `+${rawCountryCode.replace(/[^\d]/g, "")}`;
      if (sanitizedCountryCode === "+") sanitizedCountryCode = "+1";
      const phoneWithCountry = sanitizedCountryCode + getUsLocalDigits(phoneInput.value);
      const phoneFilled = hasValue(phoneInput);
      const smsConsented = phoneFilled && smsConsentInput.checked;

      if (shopifyPhoneInput) shopifyPhoneInput.value = phoneFilled ? phoneWithCountry : "";
      if (shopifySmsPhoneNoteInput) shopifySmsPhoneNoteInput.value = phoneFilled ? phoneWithCountry : "";
      if (shopifySmsConsentNoteInput) shopifySmsConsentNoteInput.value = phoneFilled ? (smsConsented ? "true" : "false") : "";

      isSubmitting = true;
      setSubmitLoading(true);
      if (turnstileSiteKey && phoneFilled && !window.__divergeTurnstileToken) {
        isSubmitting = false;
        setSubmitLoading(false);
        return;
      }
      if (config.companyId && config.listId) {
        await subscribeViaKlaviyoApi(emailValue, phoneFilled ? phoneWithCountry : "", smsConsented);
        await new Promise((resolve) => window.setTimeout(resolve, 1200));
      }
      setSubmitLoading(false);
      nativeSubmitButton.click();
    });

    emailInput.addEventListener("input", syncUi);
    emailInput.addEventListener("change", syncUi);
    phoneInput.addEventListener("input", syncUi);
    phoneInput.addEventListener("change", syncUi);
    phoneInput.addEventListener("blur", syncUi);
    countryCodeInput.addEventListener("input", () => {
      const digits = countryCodeInput.value.replace(/[^\d]/g, "");
      countryCodeInput.value = digits ? `+${digits}` : "+";
    });
    countryCodeInput.addEventListener("blur", () => {
      const digits = countryCodeInput.value.replace(/[^\d]/g, "");
      countryCodeInput.value = `+${digits || "1"}`;
    });
    syncUi();
    window.addEventListener("pageshow", syncUi);
    form.addEventListener("submit", (event) => event.preventDefault());
  };

  const newsletterForm = $("#DivergeNewsletter");
  if (newsletterForm) initNewsletterSignup(newsletterForm);

  const formatMoney = (cents, currency) => {
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents);
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "USD",
    }).format((cents || 0) / 100);
  };

  const refreshCartUi = (cart) => {
    $$("[data-cart-link]").forEach((link) => {
      const count = cart.item_count || 0;
      link.setAttribute(
        "aria-label",
        count > 0 ? `Bag, ${count} item${count === 1 ? "" : "s"}` : "Bag",
      );
      const badge = $("[data-cart-count]", link);
      if (badge) {
        if (count > 0) {
          badge.textContent = count > 99 ? "99+" : String(count);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    });
    const subtotal = $("[data-cart-subtotal]");
    if (subtotal && cart.total_price != null) {
      subtotal.textContent = formatMoney(cart.total_price, cart.currency);
    }
    cart.items?.forEach((item, index) => {
      const line = index + 1;
      const row = $(`[data-cart-line="${line}"]`);
      if (!row) return;
      const qty = $("[data-cart-quantity-value]", row);
      if (qty) qty.textContent = item.quantity;
      const price = $("[data-cart-line-price]", row);
      if (price) price.textContent = formatMoney(item.final_line_price, cart.currency);
    });
  };

  const updateBagCount = async () => {
    try {
      const cart = await fetch(window.divergeRoutes.cartJson).then((response) => response.json());
      refreshCartUi(cart);
      return cart;
    } catch (_) {
      return null;
    }
  };

  $$("[data-cart-quantity]").forEach((control) => {
    const line = Number(control.dataset.line);
    const valueNode = $("[data-cart-quantity-value]", control);
    const row = control.closest("[data-cart-line]");
    const priceNode = row ? $("[data-cart-line-price]", row) : null;
    const unitPrice = row ? Number(row.dataset.unitPrice || 0) : 0;
    let cartCurrency = "USD";
    let pendingController = null;
    let requestVersion = 0;

    control.addEventListener("click", (event) => {
      const button = event.target.closest("[data-cart-quantity-change]");
      if (!button) return;

      const delta = Number(button.dataset.cartQuantityChange);
      const current = Number(valueNode?.textContent || 0);
      const next = Math.max(0, Math.min(99, current + delta));
      if (next === current) return;

      const previousQuantity = current;
      const previousPrice = priceNode?.textContent || "";

      if (valueNode) valueNode.textContent = String(next);
      if (priceNode && unitPrice) {
        priceNode.textContent = formatMoney(unitPrice * next, cartCurrency);
      }

      if (pendingController) pendingController.abort();
      pendingController = new AbortController();
      const controller = pendingController;
      const version = ++requestVersion;

      fetch(window.divergeRoutes.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line, quantity: next }),
        signal: controller.signal,
      })
        .then((response) => {
          if (!response.ok) throw new Error("Unable to update bag");
          return response.json();
        })
        .then((cart) => {
          if (version !== requestVersion) return;
          cartCurrency = cart.currency || cartCurrency;
          if (next === 0) {
            row?.remove();
            if (cart.item_count === 0) window.location.reload();
            return;
          }
          refreshCartUi(cart);
        })
        .catch((error) => {
          if (error.name === "AbortError") return;
          if (valueNode) valueNode.textContent = String(previousQuantity);
          if (priceNode) priceNode.textContent = previousPrice;
          updateBagCount();
        });
    });
  });
  const variantInStock = (button) => {
    if (!button) return false;
    const managed = button.dataset.inventoryManaged === "true";
    const qty = Number(button.dataset.inventoryQuantity);
    if (managed && Number.isFinite(qty)) return qty > 0;
    return button.dataset.available === "true";
  };

  const variantInventoryText = (button) => {
    if (!button) return "";
    const managed = button.dataset.inventoryManaged === "true";
    const qty = Number(button.dataset.inventoryQuantity);
    const total = Number(button.dataset.totalStock);
    if (!variantInStock(button)) return "Sold out";
    if (managed && Number.isFinite(qty)) {
      if (Number.isFinite(total) && total > 0) return `${qty}/${total} Remaining`;
      return `${qty} Remaining`;
    }
    return "In stock";
  };

  $$("[data-diverge-product-form]").forEach((form) => {
    const shell = form.closest(".piece-info") || form;
    const variantInput = $('input[name="id"]', form);
    const addButton = $('[type="submit"]', shell);
    const price = $("[data-product-price]", shell);
    const inventory = $("[data-product-inventory]", shell);
    const variantButtons = $$("[data-variant-button]", form);
    let submitting = false;
    const syncVariantAvailability = () => {
      variantButtons.forEach((button) => {
        const inStock = variantInStock(button);
        button.disabled = submitting || !inStock;
        button.classList.toggle("is-unavailable", !inStock);
        if (!inStock) {
          button.setAttribute("aria-disabled", "true");
          button.setAttribute("aria-label", `${button.textContent.trim()} sold out`);
        } else {
          button.removeAttribute("aria-disabled");
          button.removeAttribute("aria-label");
        }
      });
    };
    const syncVariantUi = () => {
      syncVariantAvailability();
      let active = $(".active[data-variant-button]", form);
      if (!active || !variantInStock(active)) {
        active = variantButtons.find((button) => variantInStock(button)) || variantButtons[0];
        variantButtons.forEach((item) => {
          const selected = item === active;
          item.classList.toggle("active", selected);
          item.setAttribute("aria-pressed", selected ? "true" : "false");
        });
        if (active) {
          variantInput.value = active.dataset.variantId;
          if (price && active.dataset.price) price.textContent = active.dataset.price;
        }
      }
      if (!active) return;
      const available = variantInStock(active);
      addButton.disabled = submitting || !available;
      const label = addButton.querySelector("[data-add-label]") || addButton;
      if (label.childNodes[0]?.nodeType === Node.TEXT_NODE) {
        label.childNodes[0].textContent = available ? "Add to bag " : "Sold out ";
      }
      if (inventory) inventory.textContent = variantInventoryText(active);
    };
    variantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (submitting || button.disabled || !variantInStock(button)) return;
        variantButtons.forEach((item) => {
          item.classList.remove("active");
          item.setAttribute("aria-pressed", "false");
        });
        button.classList.add("active");
        button.setAttribute("aria-pressed", "true");
        variantInput.value = button.dataset.variantId;
        if (price && button.dataset.price) price.textContent = button.dataset.price;
        if (inventory) inventory.textContent = variantInventoryText(button);
        syncVariantUi();
      });
    });
    syncVariantUi();
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (submitting) return;
      submitting = true;
      syncVariantUi();
      try {
        const response = await fetch(window.divergeRoutes.cartAdd, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error((await response.json()).description);
        await updateBagCount();
        const toast = $("#diverge-toast");
        if (toast) {
          toast.hidden = false;
          toast.querySelector("[data-toast-message]").textContent = "Piece added to bag";
          window.setTimeout(() => (toast.hidden = true), 2600);
        }
      } catch (error) {
        const status = $("[data-product-status]", form);
        if (status) status.textContent = error.message || "Unable to add this piece.";
      } finally {
        submitting = false;
        syncVariantUi();
      }
    });
  });

  $$("[data-quantity-change]").forEach((button) => {
    button.addEventListener("click", () => {
      const control = button.closest("[data-quantity-control]");
      const input = $('input[type="number"]', control);
      if (!input) return;
      const next = Math.max(
        Number(input.min || 1),
        Math.min(Number(input.max || 99), Number(input.value || 1) + Number(button.dataset.quantityChange)),
      );
      input.value = next;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  const findProductViewScope = (button) => {
    const direct = button.closest("[data-product-gallery], [data-study-stage], [data-onbody-stage]");
    if (direct) return direct;
    const panel = button.closest("[data-study-panel], [data-onbody-panel], .piece-study-stage, .onbody-stage, .piece-page");
    return panel?.querySelector("[data-product-gallery], [data-study-stage], [data-onbody-stage]") || null;
  };

  const downscaledUrlFromMaster = (masterUrl, width) => {
    if (!masterUrl || typeof masterUrl !== "string") return null;
    const marker = "cdn.diverge.club/";
    const idx = masterUrl.indexOf(marker);
    if (idx === -1) return null;
    const tail = masterUrl.slice(idx + marker.length);
    const lastSlash = tail.lastIndexOf("/");
    const folder = lastSlash >= 0 ? tail.slice(0, lastSlash + 1) : "";
    const filename = lastSlash >= 0 ? tail.slice(lastSlash + 1) : tail;
    const stem = filename.replace(/\.[^.]+$/, "");
    return `https://cdn.diverge.club/${folder}downscaled_${stem}_${width}.webp`;
  };

  const normalizeDivergeCdnUrl = (value) => {
    if (!value) return "";
    const trimmed = String(value).trim().replace(/&amp;/g, "&");
    try {
      const url = new URL(trimmed, document.baseURI);
      if (url.hostname !== "cdn.diverge.club") return "";
      url.search = "";
      url.hash = "";
      return url.href;
    } catch {
      return "";
    }
  };

  const isDivergeCdnImageUrl = (value) => {
    const abs = normalizeDivergeCdnUrl(value);
    if (!abs) return false;
    const filename = abs.split("/").pop() || "";
    if (filename.startsWith("downscaled_")) return false;
    return /\.(png|jpe?g|webp|gif|avif)$/i.test(filename);
  };

  const applyJournalCdnImage = (img, masterUrl, { eager = false, sizes } = {}) => {
    const master = normalizeDivergeCdnUrl(masterUrl);
    if (!img || !master) return img;
    const preview = downscaledUrlFromMaster(master, 640) || master;
    img.classList.add("diverge-cdn-image");
    if (!img.alt) img.alt = "";
    if (!img.getAttribute("width")) img.width = 1122;
    if (!img.getAttribute("height")) img.height = 1402;
    img.decoding = "async";
    img.loading = eager ? "eager" : "lazy";
    if (eager) img.fetchPriority = "high";
    img.sizes = sizes || img.getAttribute("sizes") || "(max-width: 760px) 92vw, 50vw";
    img.dataset.masterUrl = master;
    img.setAttribute("data-journal-cdn", "true");
    img.removeAttribute("data-srcset");
    img.removeAttribute("srcset");
    img.removeAttribute("data-srcset-applied");
    img.removeAttribute("data-journal-cdn-upgrade");
    img.removeAttribute("data-full-loaded");
    img.src = preview;
    startJournalCdnUpgrade(img);
    return img;
  };

  const isJournalCdnImage = (img) => img?.hasAttribute?.("data-journal-cdn");

  const probeCache = new Map();

  const probeImageUrl = (url) => {
    if (!url) return Promise.resolve(false);
    if (probeCache.has(url)) return probeCache.get(url);
    const pending = new Promise((resolve) => {
      const probe = new Image();
      probe.decoding = "async";
      probe.onload = () => resolve(true);
      probe.onerror = () => resolve(false);
      probe.src = url;
    });
    probeCache.set(url, pending);
    return pending;
  };

  const buildVerifiedSrcset = async (master, preview640) => {
    const parts = [`${preview640} 640w`];
    for (const width of [1280, 1920, 2560]) {
      const url = downscaledUrlFromMaster(master, width);
      if (url && (await probeImageUrl(url))) {
        parts.push(`${url} ${width}w`);
      }
    }
    return parts.join(", ");
  };

  const startJournalCdnUpgrade = (img) => {
    if (!img || img.dataset.journalCdnUpgrade === "true") return;
    img.dataset.journalCdnUpgrade = "true";
    const master = img.dataset.masterUrl;
    if (!master) return;

    img.dataset.fullSrc = master;
    img.setAttribute("data-progressive-cdn", "true");

    afterPreviewLoad(img, async (ok) => {
      if (!ok) return;
      if (!isFramedStudyImage(img) && img.naturalWidth > 0 && img.naturalHeight > 0) {
        img.width = img.naturalWidth;
        img.height = img.naturalHeight;
        img.style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`;
      }
      lockFramedCdnImage(img);
      const preview640 = img.currentSrc || img.src || downscaledUrlFromMaster(master, 640);
      const srcset = await buildVerifiedSrcset(master, preview640);
      if (srcset) {
        img.dataset.srcset = srcset;
        img.dataset.srcsetApplied = "true";
        img.srcset = srcset;
      }

      if (isInHiddenSubtree(img)) return;

      let startedPng = false;
      const startPng = () => {
        if (startedPng) return;
        startedPng = true;
        upgradeToFullRes(img);
      };
      img.addEventListener("load", startPng, { once: true });
      window.setTimeout(startPng, 2500);
    });
  };

  const preloadedUrls = new Set();

  const scheduleIdle = (fn, delay = 400) => {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(fn, { timeout: 3000 });
    } else {
      window.setTimeout(fn, delay);
    }
  };

  const preloadImageUrl = (url) => {
    if (!url || preloadedUrls.has(url)) return;
    preloadedUrls.add(url);
    const img = new Image();
    img.decoding = "async";
    img.src = url;
  };

  const preloadCdnMaster = (masterUrl) => {
    if (!masterUrl) return;
    preloadImageUrl(downscaledUrlFromMaster(masterUrl, 640) || masterUrl);
  };

  const applyCdnSrcset = (img) => {
    if (!img || img.dataset.srcsetApplied === "true") return Promise.resolve();
    const master = img.dataset.masterUrl;
    const preview640 = downscaledUrlFromMaster(master, 640) || img.getAttribute("src") || img.currentSrc;
    if (!master || !preview640) return Promise.resolve();
    img.dataset.srcsetApplied = "true";
    return buildVerifiedSrcset(master, preview640).then((srcset) => {
      if (!srcset || !img.isConnected) return;
      img.dataset.srcset = srcset;
      img.srcset = srcset;
    });
  };

  const afterPreviewLoad = (img, fn) => {
    if (!img) return;
    const run = (ok) => fn(ok);
    if (img.complete) {
      run(img.naturalWidth > 0);
      return;
    }
    img.addEventListener("load", () => run(true), { once: true });
    img.addEventListener("error", () => run(false), { once: true });
  };

  const upgradeToFullRes = (img) => {
    const full = img?.dataset?.fullSrc;
    if (!full || img.dataset.fullLoaded === "true") return;
    const loader = new Image();
    loader.onload = () => {
      img.src = full;
      img.removeAttribute("srcset");
      img.dataset.fullLoaded = "true";
      img.classList.add("is-full-res");
      lockFramedCdnImage(img);
      lockProductCdnImage(img);
    };
    loader.src = full;
  };

  const isLazyCdnImage = (img) => img?.hasAttribute?.("data-lazy-cdn");

  const isInHiddenSubtree = (el) => {
    let node = el;
    while (node) {
      if (node.hidden) return true;
      node = node.parentElement;
    }
    return false;
  };

  const isFramedStudyImage = (img) =>
    Boolean(img?.closest(".onbody-art, .onbody-sketch-frame, .onbody-preview-grid a, .onbody-flats button"));

  const isProductDisplayImage = (img) => Boolean(img?.closest(".product-image"));

  const lockProductCdnImage = (img) => {
    if (!img || !isProductDisplayImage(img) || isFramedStudyImage(img)) return;
    img.removeAttribute("width");
    img.removeAttribute("height");
    img.style.removeProperty("aspect-ratio");
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.maxWidth = "none";
    img.style.maxHeight = "none";
    img.style.position = "absolute";
    img.style.inset = "0";
    img.style.display = "block";
    img.style.objectPosition = "center center";
  };

  const lockFramedCdnImage = (img) => {
    if (!isFramedStudyImage(img)) return;
    img.removeAttribute("width");
    img.removeAttribute("height");
    img.style.removeProperty("aspect-ratio");
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.maxWidth = "none";
    img.style.maxHeight = "none";
    img.style.objectFit = "cover";
    img.style.objectPosition = "center center";
    img.style.position = "absolute";
    img.style.inset = "0";
    img.style.display = "block";
  };

  const lockFramedImagesInScope = (scope) => {
    if (!scope) return;
    scope.querySelectorAll(".onbody-art img, .onbody-sketch-frame img, .onbody-flats img").forEach((img) => {
      lockFramedCdnImage(img);
    });
  };

  const lockProductImagesInScope = (scope = document) => {
    scope.querySelectorAll(".product-image img").forEach((img) => {
      lockProductCdnImage(img);
    });
  };

  const startCdnUpgrade = (img, { allowProgressive = true } = {}) => {
    if (!img || img.dataset.cdnUpgrade === "true") return;
    img.dataset.cdnUpgrade = "true";
    lockFramedCdnImage(img);
    lockProductCdnImage(img);
    afterPreviewLoad(img, async (ok) => {
      if (!ok) return;
      lockFramedCdnImage(img);
      lockProductCdnImage(img);
      await applyCdnSrcset(img);
      lockFramedCdnImage(img);
      lockProductCdnImage(img);
      if (
        isFramedStudyImage(img) ||
        !allowProgressive ||
        !img.hasAttribute("data-progressive-cdn") ||
        isInHiddenSubtree(img)
      ) {
        return;
      }
      let startedPng = false;
      const startPng = () => {
        if (startedPng) return;
        startedPng = true;
        upgradeToFullRes(img);
      };
      img.addEventListener("load", startPng, { once: true });
      window.setTimeout(startPng, 2000);
    });
  };

  const hydrateLazyCdnImage = (img, { allowProgressive = true } = {}) => {
    if (!isLazyCdnImage(img) || img.dataset.lazyHydrated === "true") return;
    const src = img.dataset.src;
    if (!src) return;
    img.loading = "eager";
    img.src = src;
    img.removeAttribute("data-src");
    img.dataset.lazyHydrated = "true";
    startCdnUpgrade(img, { allowProgressive });
  };

  const hydrateImagesInScope = (scope, options = {}) => {
    if (!scope) return;
    $$("img[data-lazy-cdn]", scope).forEach((img) => hydrateLazyCdnImage(img, options));
  };

  const preloadCdnImageEl = (img) => {
    hydrateLazyCdnImage(img, { allowProgressive: !isInHiddenSubtree(img) });
    preloadImageUrl(img.getAttribute("src") || img.dataset.src);
    startCdnUpgrade(img, { allowProgressive: !isInHiddenSubtree(img) });
  };

  const warmLazyImagesInScope = (scope, options = {}) => {
    if (!scope) return;
    $$("img[data-master-url], img[data-src], img.diverge-cdn-image", scope).forEach((img) => {
      hydrateLazyCdnImage(img, options);
      startCdnUpgrade(img, options);
    });
  };

  const initPageImageWarmup = () => {
    $$("img[data-master-url], img[data-src], img.diverge-cdn-image").forEach((img) => {
      if (isJournalCdnImage(img)) return;
      if (isInHiddenSubtree(img)) return;
      preloadCdnImageEl(img);
    });
  };

  const initProgressiveCdnImages = () => {
    $$("img[data-master-url]").forEach((img) => {
      lockFramedCdnImage(img);
      lockProductCdnImage(img);
      if (isJournalCdnImage(img)) return;
      if (isInHiddenSubtree(img)) return;
      startCdnUpgrade(img, { allowProgressive: !isInHiddenSubtree(img) });
    });
    $$(".onbody-panels > .onbody-stage:not([hidden])").forEach((panel) => {
      lockFramedImagesInScope(panel);
    });
    lockProductImagesInScope();
  };

  const initAdjacentPreload = () => {
    const node = $("#diverge-adjacent-images");
    if (!node) return;
    let data;
    try {
      data = JSON.parse(node.textContent);
    } catch {
      return;
    }
    const run = () => {
      if (data.next?.full) preloadCdnMaster(data.next.full);
      if (data.next?.back) preloadCdnMaster(data.next.back);
      if (data.prev?.full) preloadCdnMaster(data.prev.full);
      if (data.prev?.back) preloadCdnMaster(data.prev.back);
    };
    scheduleIdle(run);

    $$(".product-pagination a").forEach((link) => {
      link.addEventListener(
        "mouseenter",
        () => {
          const href = link.getAttribute("href");
          if (!href || link.dataset.pagePrefetched === "true") return;
          link.dataset.pagePrefetched = "true";
          const prefetch = document.createElement("link");
          prefetch.rel = "prefetch";
          prefetch.href = href;
          document.head.appendChild(prefetch);
          if (href.includes(data.next?.page) || href.endsWith(data.next?.page)) {
            if (data.next?.full) preloadCdnMaster(data.next.full);
            if (data.next?.back) preloadCdnMaster(data.next.back);
          }
          if (href.includes(data.prev?.page) || href.endsWith(data.prev?.page)) {
            if (data.prev?.full) preloadCdnMaster(data.prev.full);
            if (data.prev?.back) preloadCdnMaster(data.prev.back);
          }
        },
        { once: true },
      );
    });
  };

  const setProductView = (scope, view) => {
    if (!scope) return;
    const panel = scope.closest("[data-study-panel], [data-onbody-panel], .piece-study-stage, .onbody-stage, .piece-page");
    const controls = panel
      ? $$("[data-product-view]", panel)
      : $$("[data-product-view]", scope.parentElement || scope);
    controls.forEach((item) => {
      const active = item.dataset.productView === view;
      item.classList.toggle("active", active);
      item.setAttribute("aria-pressed", active ? "true" : "false");
    });
    $$("[data-view-image]", scope).forEach((image) => {
      image.hidden = image.dataset.viewImage !== view;
      if (!image.hidden) {
        warmLazyImagesInScope(image, { allowProgressive: true });
      }
    });
    const metaLabel = panel?.querySelector("[data-onbody-meta-label]");
    if (metaLabel) {
      if (view === "sketch") metaLabel.textContent = "Pencil study";
      else if (view === "onbody-alt") metaLabel.textContent = "Alt view";
      else metaLabel.textContent = "On body";
    }
    panel?.querySelectorAll("[data-onbody-thumb]").forEach((thumb) => {
      thumb.classList.toggle("active", thumb.dataset.onbodyThumb === view);
    });
  };

  $$("[data-product-view]").forEach((button) => {
    button.addEventListener("click", () => {
      const scope = findProductViewScope(button);
      if (!scope) return;
      setProductView(scope, button.dataset.productView);
    });
  });

  const shopSearch = $("#shop-search");
  const bindCatalogFilterGroup = (selector, activeKey) => {
    $$(selector).forEach((button) => {
      button.addEventListener("click", () => {
        $$(selector).forEach((item) => {
          item.classList.toggle("active", item === button);
          item.setAttribute("aria-pressed", item === button ? "true" : "false");
        });
        applyCatalogFilters();
      });
    });
  };
  const applyCatalogFilters = () => {
    const activeType = $("[data-shop-type-filter].active")?.dataset.shopTypeFilter || "all";
    const activeColor = $("[data-shop-color-filter].active")?.dataset.shopColorFilter || "all";
    const query = (shopSearch?.value || "").trim().toLowerCase();
    let count = 0;
    $$("[data-product-card]").forEach((card) => {
      const matchesType =
        activeType === "all" || (card.dataset.productType || "") === activeType;
      const matchesColor =
        activeColor === "all" || (card.dataset.productColor || "") === activeColor;
      const matchesQuery = (card.dataset.search || "").toLowerCase().includes(query);
      card.hidden = !(matchesType && matchesColor && matchesQuery);
      if (!card.hidden) count += 1;
    });
    const countNode = $("#diverge-result-count");
    if (countNode) countNode.textContent = `${count} PIECE${count === 1 ? "" : "S"} FOUND`;
  };
  bindCatalogFilterGroup("[data-shop-type-filter]");
  bindCatalogFilterGroup("[data-shop-color-filter]");
  shopSearch?.addEventListener("input", applyCatalogFilters);

  const initOnbodyGroups = () => {
    $$("[data-onbody-group]").forEach((group) => {
      const tabs = $$("[data-onbody-tab]", group);
      const panels = $$("[data-onbody-panel]", group);
      if (!tabs.length || !panels.length) return;

      const panelForTab = (tab) =>
        panels.find((panel) => panel.dataset.onbodyPanel === tab.dataset.onbodyTab) || null;

      const warmPanel = (panel) => {
        if (!panel) return;
        warmLazyImagesInScope(panel, { allowProgressive: false });
      };

      const showPanel = (button) => {
        const target = button.dataset.onbodyTab;
        const activePanel = panelForTab(button);
        if (!activePanel) return;

        tabs.forEach((tab) => {
          const selected = tab === button;
          tab.classList.toggle("active", selected);
          tab.setAttribute("aria-selected", selected ? "true" : "false");
          tab.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.onbodyPanel !== target;
        });

        lockFramedImagesInScope(activePanel);
        warmPanel(activePanel);

        const stage = $("[data-onbody-stage]", activePanel);
        if (stage) {
          setProductView(stage, "sketch");
        }
      };

      tabs.forEach((button, index) => {
        const prewarm = () => warmPanel(panelForTab(button));
        button.addEventListener("mouseenter", prewarm);
        button.addEventListener("focus", prewarm);

        button.addEventListener("click", () => showPanel(button));
        button.addEventListener("keydown", (event) => {
          let next = index;
          if (event.key === "ArrowRight") next = (index + 1) % tabs.length;
          else if (event.key === "ArrowLeft") next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === "Home") next = 0;
          else if (event.key === "End") next = tabs.length - 1;
          else return;
          event.preventDefault();
          showPanel(tabs[next]);
          tabs[next].focus();
        });
      });

    });
  };

  const initStoryMediaCrop = () => {
    $$(".story-media").forEach((frame) => {
      const img = $("img", frame);
      if (!img) return;

      const apply = () => {
        const { naturalWidth, naturalHeight } = img;
        if (!naturalWidth || !naturalHeight) return;
        const pad = (naturalHeight / naturalWidth) * 50;
        frame.style.setProperty("--story-media-crop-pad", `${pad}%`);
      };

      if (img.complete) apply();
      else img.addEventListener("load", apply, { once: true });
    });
  };

  initOnbodyGroups();

  initProgressiveCdnImages();
  initAdjacentPreload();
  initPageImageWarmup();
  initStoryMediaCrop();
  $$("img[data-master-url]").forEach((img) => {
    img.addEventListener("error", () => {
      const master = img.dataset.masterUrl;
      if (!master) return;
      const preview = downscaledUrlFromMaster(master, 640);
      const shown = img.currentSrc || img.src;
      if (preview && shown !== preview && img.dataset.previewRestore !== "true") {
        img.dataset.previewRestore = "true";
        img.removeAttribute("srcset");
        img.src = preview;
        return;
      }
      if (isJournalCdnImage(img)) {
        if (img.dataset.masterFallback === "true") return;
        img.dataset.masterFallback = "true";
        img.src = master;
        return;
      }
      if (img.dataset.masterFallback === "true") return;
      img.dataset.masterFallback = "true";
      img.src = master;
      img.removeAttribute("srcset");
      if (img.hasAttribute("data-progressive-cdn")) upgradeToFullRes(img);
    });
  });

  const initJournalEntry = () => {
    const journalRoot = document.querySelector("[data-journal-root]:not([data-journal-built])");
    if (!journalRoot) return;

    const sourceNode = journalRoot.querySelector("[data-journal-source]");
    const layout = journalRoot.querySelector("[data-journal-layout]");
    if (!sourceNode || !layout) return;
    const source = sourceNode.content || sourceNode;

    const unwrapTags = new Set([
      "DIV",
      "SPAN",
      "ARTICLE",
      "SECTION",
      "MAIN",
      "HEADER",
      "FOOTER",
      "CENTER",
    ]);
    const textTags = new Set([
      "P",
      "H1",
      "H2",
      "H3",
      "H4",
      "H5",
      "H6",
      "UL",
      "OL",
      "BLOCKQUOTE",
      "HR",
      "TABLE",
      "PRE",
      "DL",
      "DETAILS",
    ]);
    const ignoreTags = new Set(["META", "LINK", "STYLE", "SCRIPT", "NOSCRIPT", "BR"]);

    const normalizeText = (value) => value.replace(/\u00a0/g, " ").trim();

    const cloneNode = (node) => node.cloneNode(true);

    const flattenElements = (container) => {
      const elements = [];
      const visit = (parent) => {
        [...parent.childNodes].forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = normalizeText(node.textContent);
            if (!text) return;
            const paragraph = document.createElement("p");
            paragraph.textContent = text;
            elements.push(paragraph);
            return;
          }
          if (!(node instanceof Element)) return;
          if (ignoreTags.has(node.tagName) || node.hidden) return;

          if (node.tagName === "A" && node.querySelector("img") && !normalizeText(node.textContent)) {
            elements.push(node);
            return;
          }

          if (unwrapTags.has(node.tagName) || node.classList.contains("shopify-block")) {
            visit(node);
            return;
          }

          if (node.tagName === "IFRAME" || node.tagName === "VIDEO" || node.tagName === "AUDIO") {
            elements.push(node);
            return;
          }

          if (textTags.has(node.tagName)) {
            elements.push(node);
            return;
          }

          if (node.querySelector("img, picture, figure, video, iframe")) {
            visit(node);
            return;
          }

          if (normalizeText(node.textContent)) {
            elements.push(node);
          }
        });
      };
      visit(container);
      return elements;
    };

    const isImageElement = (el) => {
      if (!(el instanceof Element)) return false;
      if (el.tagName === "IMG" || el.tagName === "PICTURE") return true;
      if (el.tagName === "FIGURE") return Boolean(el.querySelector("img, picture, video"));
      if (el.tagName === "A") return Boolean(el.querySelector("img, picture"));
      const media = el.querySelector("img, picture, video");
      if (!media) return false;
      const clone = el.cloneNode(true);
      clone.querySelectorAll("img, picture, video, figure, svg").forEach((node) => node.remove());
      return normalizeText(clone.textContent).length === 0;
    };

    const extractCdnImageUrl = (el) => {
      if (!(el instanceof Element)) return "";
      if (el.tagName === "IMG") {
        const src = el.getAttribute("src") || el.dataset.src || el.dataset.masterUrl || "";
        return isDivergeCdnImageUrl(src) ? normalizeDivergeCdnUrl(src) : "";
      }
      const nestedImg = el.querySelector("img");
      if (nestedImg) {
        const fromImg = extractCdnImageUrl(nestedImg);
        if (fromImg) return fromImg;
      }
      const href = el.tagName === "A" ? el.getAttribute("href") || "" : "";
      if (isDivergeCdnImageUrl(href)) {
        const text = normalizeText(el.textContent);
        if (!text || text === href || text === normalizeDivergeCdnUrl(href)) {
          return normalizeDivergeCdnUrl(href);
        }
      }
      const onlyLink = el.querySelector(":scope > a");
      if (
        onlyLink &&
        el.children.length === 1 &&
        isDivergeCdnImageUrl(onlyLink.getAttribute("href"))
      ) {
        const text = normalizeText(el.textContent);
        const linkHref = onlyLink.getAttribute("href") || "";
        if (!text || text === linkHref || text === normalizeText(onlyLink.textContent)) {
          return normalizeDivergeCdnUrl(linkHref);
        }
      }
      const text = normalizeText(el.textContent);
      return isDivergeCdnImageUrl(text) ? normalizeDivergeCdnUrl(text) : "";
    };

    const isMeaningfulTextNode = (el) => {
      if (!(el instanceof Element)) return false;
      if (el.tagName === "HR" || el.tagName === "TABLE") return true;
      if (el.tagName === "IFRAME" || el.tagName === "VIDEO" || el.tagName === "AUDIO") return true;
      return normalizeText(el.textContent).length > 0;
    };

    const parseBlocks = (container) => {
      const elements = flattenElements(container);
      const blocks = [];
      let textNodes = [];

      const flushText = () => {
        const meaningful = textNodes.filter(isMeaningfulTextNode);
        textNodes = [];
        if (!meaningful.length) return;
        blocks.push({ type: "text", nodes: meaningful });
      };

      elements.forEach((el) => {
        if (isImageElement(el) || extractCdnImageUrl(el)) {
          flushText();
          blocks.push({ type: "image", nodes: [el] });
          return;
        }
        if (
          textTags.has(el.tagName) ||
          el.tagName === "IFRAME" ||
          el.tagName === "VIDEO" ||
          el.tagName === "AUDIO"
        ) {
          textNodes.push(el);
          return;
        }
        if (normalizeText(el.textContent)) {
          textNodes.push(el);
          return;
        }
        flushText();
        blocks.push({ type: "unknown", nodes: [el] });
      });

      flushText();
      return blocks;
    };

    const buildRows = (blocks) => {
      const rows = [];
      for (let i = 0; i < blocks.length; i += 1) {
        const current = blocks[i];
        const next = blocks[i + 1];
        if (current.type === "text" && next?.type === "image") {
          rows.push({ kind: "pair", text: current, image: next });
          i += 1;
        } else if (current.type === "image") {
          rows.push({ kind: "media", image: current });
        } else if (current.type === "text") {
          rows.push({ kind: "text", text: current });
        } else if (current.type === "unknown") {
          rows.push({ kind: "extra", unknown: current });
        }
      }
      return rows;
    };

    const appendTextNodes = (target, nodes) => {
      nodes.forEach((node) => target.appendChild(cloneNode(node)));
    };

    const createMediaCell = (imageNode, { eager = false, fullBleed = false } = {}) => {
      const media = document.createElement("div");
      media.className = "journal-row-media";
      const sizes = fullBleed
        ? "(max-width: 760px) 92vw, min(980px, 92vw)"
        : "(max-width: 760px) 92vw, 50vw";
      const cdnUrl = extractCdnImageUrl(imageNode);
      if (cdnUrl) {
        const cloned = cloneNode(imageNode);
        const img = cloned.tagName === "IMG" ? cloned : cloned.querySelector("img");
        if (img) {
          applyJournalCdnImage(img, cdnUrl, { eager, sizes });
          media.appendChild(cloned.tagName === "FIGURE" ? cloned : img);
        } else {
          const created = document.createElement("img");
          applyJournalCdnImage(created, cdnUrl, { eager, sizes });
          media.appendChild(created);
        }
        return media;
      }
      media.appendChild(cloneNode(imageNode));
      return media;
    };

    const blocks = parseBlocks(source);
    if (!blocks.length) return;

    const rows = buildRows(blocks);
    layout.replaceChildren();
    let pairIndex = 0;
    let imageIndex = 0;
    let introApplied = false;

    rows.forEach((row, index) => {
      const isLastSolo =
        index === rows.length - 1 && (row.kind === "text" || row.kind === "media");

      if (row.kind === "pair") {
        const rowEl = document.createElement("div");
        rowEl.className = `journal-row journal-row--${pairIndex % 2 === 0 ? "odd" : "even"}`;

        const copy = document.createElement("div");
        copy.className = "journal-row-copy rte";
        if (!introApplied) {
          copy.classList.add("journal-intro");
          introApplied = true;
        }
        appendTextNodes(copy, row.text.nodes);

        rowEl.append(
          copy,
          createMediaCell(row.image.nodes[0], { eager: imageIndex === 0, fullBleed: false }),
        );
        layout.appendChild(rowEl);
        pairIndex += 1;
        imageIndex += 1;
        return;
      }

      if (row.kind === "media") {
        const rowEl = document.createElement("div");
        rowEl.className = "journal-row journal-row--media-only";
        if (isLastSolo) rowEl.classList.add("journal-row--solo");
        rowEl.appendChild(
          createMediaCell(row.image.nodes[0], { eager: imageIndex === 0, fullBleed: true }),
        );
        layout.appendChild(rowEl);
        imageIndex += 1;
        return;
      }

      if (row.kind === "text") {
        const box = document.createElement("div");
        box.className = isLastSolo ? "journal-text rte journal-text--solo" : "journal-text rte";
        if (!introApplied) {
          box.classList.add("journal-intro");
          introApplied = true;
        }
        appendTextNodes(box, row.text.nodes);
        layout.appendChild(box);
        return;
      }

      if (row.kind === "extra") {
        const box = document.createElement("div");
        box.className = "journal-extra rte";
        appendTextNodes(box, row.unknown.nodes);
        layout.appendChild(box);
      }
    });

    if (!layout.children.length) return;

    layout.hidden = false;
    layout.removeAttribute("aria-hidden");
    journalRoot.dataset.journalBuilt = "true";

    [...layout.querySelectorAll("img[data-master-url]")].forEach((img, index) => {
      if (index === 0) return;
      scheduleIdle(() => preloadCdnMaster(img.dataset.masterUrl));
    });
  };

  initJournalEntry();
  document.addEventListener("shopify:section:load", initJournalEntry);
  window.addEventListener("pageshow", initJournalEntry);

  const initJournalListPrefetch = () => {
    const warm = (link) => {
      (link.dataset.journalPreloads || "")
        .split(",")
        .map((url) => url.trim())
        .filter(Boolean)
        .forEach((url) => preloadImageUrl(url));
    };
    const links = $$("a[data-journal-preloads]");
    if (links[0]) warm(links[0]);
    links.forEach((link) => {
      const run = () => warm(link);
      link.addEventListener("pointerenter", run, { once: true });
      link.addEventListener("touchstart", run, { once: true, passive: true });
      link.addEventListener("focus", run, { once: true });
    });
  };
  initJournalListPrefetch();

  $$("[data-onbody-thumb]").forEach((button) => {
    button.addEventListener("click", () => {
      const panel = button.closest("[data-onbody-panel]");
      const stage = panel?.querySelector("[data-onbody-stage]");
      if (!stage) return;
      setProductView(stage, button.dataset.onbodyThumb);
    });
  });

  window.addEventListener("pageshow", () => {
    if (!intro?.isConnected && !activeDrawer) unlock();
    updateBagCount();
  });
})();
